<template>
    <div>
        <app-layout>  
            <template v-slot:header>
                <Header :title="$t('coop_companies')"
                        :isNewButton="true"
                        @new-button-click="createFormShow()"
                        @filter-div-status="datatable.filterStatus = $event">
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('coop_companies')"
                              :isNewButton="true"
                              @new-button-click="createFormShow()"
                              @filter-div-status="datatable.filterStatus = $event">
                </HeaderMobile>
            </template>

            <datatable-filter v-show="datatable.filterStatus"
                              @filter="filter"
                              @filterClear="filterClear"
                              :export-excel="true"
                              @exportExcel="exportExcel()">
                <b-row>
                    <b-col sm="6" md="2">
                        <b-form-group :label="$t('id')">
                            <b-form-input v-model="datatable.queryParams.filter.id"/>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="2">
                        <b-form-group :label="$t('coop_company_code')">
                            <b-form-input v-model="datatable.queryParams.filter.company_code"/>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="3">
                        <b-form-group :label="$t('company_name')">
                            <b-form-input v-model="datatable.queryParams.filter.name"/>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="3">
                        <b-form-group :label="$t('address')">
                            <b-form-input v-model="datatable.queryParams.filter.address"/>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="2">
                        <b-form-group :label="$t('status')">
                            <b-form-select v-model="datatable.queryParams.filter.status" :options="statusFilterOptions" />
                        </b-form-group>
                    </b-col>
                </b-row>
            </datatable-filter>

            <datatable ref="datatable"
                       :isLoading.sync="datatable.isLoading"
                       :columns="datatable.columns"
                       :rows="datatable.rows"
                       :total="datatable.total"
                       :queryParams="datatable.queryParams"
                       :lineNumbers="false"
                       @on-page-change="onPageChange"
                       @on-sort-change="onSortChange"
                       @on-per-page-change="onPerPageChange"
                       v-show="datatable.showTable"
                       :data-function="callService"
            />

            <CommonModal ref="showModal" size="lg" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
                <template v-slot:CommonModalTitle>
                    {{ $t(modalTitle) }}
                </template>
                <template v-slot:CommonModalContent>
                    <component v-if="modalComponent"
                               :is="modalComponent"
                               @createFormSuccess="actionSuccess"
                               @updateFormSuccess="actionSuccess"
                               @actionSuccess="actionSuccess"
                               :formId="formId"/>
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
    //Template
    import AppLayout from '@/layouts/AppLayout';
    import Header from '@/layouts/AppLayout/Header';
    import HeaderMobile from '@/layouts/AppLayout/HeaderMobile';

    //Component
    import DatatableFilter from '@/components/datatable/DatatableFilter';
    import Datatable from '@/components/datatable/Datatable';
    import CommonModal from '@/components/elements/CommonModal';

    //Page
    import CreateForm from './CreateForm';
    import UpdateForm from './UpdateForm';

    //Service
    import CoopCompanyService from '@/services/CoopCompanyService';

    //Other
    import qs from 'qs';

    export default {
        components: {
            AppLayout,
            Header,
            HeaderMobile,

            DatatableFilter,
            Datatable,
            CommonModal,

            CreateForm,
            UpdateForm
        },
        metaInfo() {
            return {
                title: this.$t('coop_companies')
            }
        },
        data() {
            return {
                formId: null,
                modalTitle: null,
                modalComponent: null,
                statusFilterOptions: [
                    {value: null, text: ''},
                    {value: 'active', text: this.$t('active')},
                    {value: 'passive', text: this.$t('passive')}
                ],
                datatable: {
                    isLoading: false,
                    columns: [
                        {
                            label: '',
                            field: 'buttons',
                            html: true,
                            hidden: false,
                            tdClass: 'p-0 text-center w-40 align-middle',
                            buttons: [
                                {
                                    text: this.$t('show_or_update'),
                                    class: 'ri-edit-box-line',
                                    callback: (row) => {
                                        this.updateFormShow(row.id);
                                    }
                                },
                                {
                                    text: this.$t('delete'),
                                    class: 'ri-delete-bin-2-line',
                                    callback: (row) => {
                                        this.formDelete(row.id);
                                    }
                                }
                            ]
                        },
                        {
                            label: this.toUpperCase('coop_company_code'),
                            field: 'company_code',
                            formatFn: (val, row) => row.company_code || row.company_id || '-',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('company_name'),
                            field: 'name',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('address'),
                            field: 'address',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('coop_staff_count'),
                            field: 'employee_count',
                            formatFn: (val, row) => row.employee_count ?? row.staff_count ?? '-',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('status'),
                            field: 'status',
                            formatFn: (status) => {
                                return status === 'active' ? this.$t('active') : this.$t('passive');
                            },
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('description'),
                            field: 'description',
                            hidden: false
                        }
                    ],
                    rows: [],
                    total: 0,
                    filterStatus: true,
                    showTable: false,
                    queryParams: {
                        filter: {},
                        sort: 'id',
                        page: 1,
                        limit: 20
                    }
                }
            };
        },
        methods: {
            callService(config) {
                return CoopCompanyService.getAll(config);
            },
            filter() {
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            filterClear() {
                this.datatable.queryParams.filter = {};
                this.getRows();
            },
            onPageChange(params) {
                this.datatable.queryParams.page = params.currentPage;
                this.getRows();
            },
            onPerPageChange(params) {
                this.datatable.queryParams.limit = params.currentPerPage;
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            onSortChange(params) {
                const sortType = params[0].type == 'desc' ? '-' : '';
                this.datatable.queryParams.sort = sortType + params[0].field;
                this.getRows();
            },
            getRows() {
                this.datatable.showTable = true;
                this.datatable.isLoading = true;

                const config = {
                    params: {
                        ...this.datatable.queryParams
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                };

                return CoopCompanyService.getAll(config)
                    .then((response) => {
                        this.datatable.rows = response.data.data;
                        this.datatable.total = response.data.pagination?.total || response.data.data.length;
                    })
                    .finally(() => {
                        this.datatable.isLoading = false;
                    });
            },
            createFormShow() {
                this.formId = null;
                this.modalComponent = 'create-form';
                this.modalTitle = 'new';
                this.$refs.showModal.$refs.commonModal.show();
            },
            updateFormShow(id) {
                this.formId = id;
                this.modalComponent = 'update-form';
                this.modalTitle = 'show_or_update';
                this.$refs.showModal.$refs.commonModal.show();
            },
            formDelete(id) {
                this.$swal.fire({
                    text: this.$t('are_you_sure_to_delete'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('yes'),
                    cancelButtonText: this.$t('no')
                }).then((result) => {
                    if (result.isConfirmed) {
                        CoopCompanyService.remove(id)
                            .then(response => {
                                this.$toast.success(this.$t('api.' + response.data.message));
                                this.getRows();
                                this.formClear();
                            });
                    }
                });
            },
            exportExcel() {
                const config = {
                    params: {
                        ...this.datatable.queryParams
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                };
                CoopCompanyService.excelExport(config)
                    .then(response => {
                        this._downloadFile(response, 'Companies.xlsx');
                    })
                    .catch(() => {});
            },
            formClear() {
                this.formId = null;
                this.modalComponent = null;
                this.modalTitle = null;
            },
            actionSuccess() {
                this.$refs.showModal.$refs.commonModal.hide();
                this.getRows();
                this.formClear();
            }
        },
        created() {
            this.getRows();
        }
    }
</script>
